module.exports = __webpack_public_path__ + "static/img/countermeasures_2025.27465c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/countermeasures_2025.jpg
// module id = kf/A
// module chunks = 100